import {
    WF_ACTIVITY_REGISTRY,
    WfActivityRegistryEntry
} from '../wf/interface/wf-activity-registry';
import {
    WfProcessStepActivityUfFormComponent
} from '../wf/component/protected-components/process-activity/wf-process-step-activity-uf-form/wf-process-step-activity-uf-form.component';
import {
    WfProcessStepActivityUfFlowComponent
} from '../wf/component/protected-components/process-activity/wf-process-step-activity-uf-flow/wf-process-step-activity-uf-flow.component';

export const UF_WF_ACTIVITY_PROVIDER = [{
    provide: WF_ACTIVITY_REGISTRY,
    useValue: [
        ['uf_form', {mainComponent: WfProcessStepActivityUfFormComponent}],
        ['uf_flow', {mainComponent: WfProcessStepActivityUfFlowComponent}],
    ] as WfActivityRegistryEntry[],
    multi: true
}];
